module.exports = __webpack_public_path__ + "img/grand-cancun-hotel-2.ab1f9335.jpg";